import React from "react";
import PropTypes from "prop-types";
import { Link, graphql, StaticQuery } from "gatsby";
import PreviewCompatibleImage from "./PreviewCompatibleImage";

const blogCardElement=(post)=>{
  console.log("post::"+post);
  return(
    <div class="box" style={{margin:0,padding:0}}>
    <div class="container" >
    <div class="columns">
  <div class="column is-one-quarter" style={{margin:0,padding:0}}>
  {post.frontmatter.featuredimage ? (
    <div class="card-image" >
    
    
    <PreviewCompatibleImage
        imageInfo={{
          image: post.frontmatter.featuredimage,
          alt: `featured image thumbnail for post ${post.frontmatter.title}`,
        }}
      />
     
    </div>):null}
  </div>
  <div class="column">
  <h5 style={{margin:0,padding:0}}>{post.frontmatter.title}</h5>
  <p style={{margin:0,padding:0,fontSize:10}}>{post.frontmatter.date}</p>  
  <p style={{marginTop:10,fontSize:12,paddingRight:10}}>{post.frontmatter.description}Read More...</p>

  
  </div>
  </div>
  </div>
</div>
    
  )
}

class BlogRoll extends React.Component {
  render() {
    console.log(this.props)
    const { data } = this.props;
    const { edges: posts } = data.allMarkdownRemark;
  

    return (
      <div style={{alignContent:'center',width:'80%'}}>
        {posts &&
          posts.map(({ node: post }) => (
            <div key={post.id} style={{marginBottom:35}}>
              <Link to={post.fields.slug}>
             {blogCardElement(post)}
             </Link>
            </div>
           
          ))}
      </div>
    );
  }
}

BlogRoll.propTypes = {
  data: PropTypes.shape({
    allMarkdownRemark: PropTypes.shape({
      edges: PropTypes.array,
    }),
  }),
};

export default () => (
  <StaticQuery
    query={graphql`
      query BlogRollQuery {
        allMarkdownRemark(
          sort: { order: DESC, fields: [frontmatter___date] }
          filter: { frontmatter: { templateKey: { eq: "blog-post" } } }
        ) {
          edges {
            node {
              excerpt(pruneLength: 400)
              id
              fields {
                slug
              }
              frontmatter {
                title
                templateKey
                date(formatString: "MMMM DD, YYYY")
                featuredpost
                description
                featuredimage {
                  childImageSharp {
                    fluid(maxWidth: 80, quality: 100) {
                      ...GatsbyImageSharpFluid
                    }
                  }
                }
              }
            }
          }
        }
      }
    `}
    render={(data, count) => <BlogRoll data={data} count={count} />}
  />
);
